module.exports = __webpack_public_path__ + "img/rcc-logo-grey.8dc60162.png";